<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm9>
        <v-layout wrap>
          <v-flex sm6 xs12>
            <v-layout wrap>
              <v-flex xs11>
                <h1 class="mb-1">
                  {{ $t('a') }}
                </h1>
                <div class="mb-4">
                  <small>
                    <div>{{ $t('b') }}</div>
                    <div>{{ $t('c') }}</div>
                    <div class="mt-3"><b>{{ $t('d') }} 👉</b></div>
                    <div class="mt-3"><b>{{ $t('e') }}</b></div>
                  </small>
                </div>
              </v-flex>
            </v-layout>
            <v-layout wrap v-for="index in 7" :key="index" mb-4>
              <v-flex xs11>
                <v-card class="px-4 py-2" outlined>
                  <small>
                    <div><b>{{ $t(`feature${index}Title`) }}</b></div>
                    <div>{{ $t(`feature${index}Description`) }}</div>
                  </small>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="user.data.locale === 'fr'" sm6 xs12 mb-4>
            <div id="wrapper" data-tf-widget="uy0r7Sza" :data-tf-hidden="dataTfHidden" data-tf-inline-on-mobile data-tf-medium="snippet" style="width:100%;height:100%;"></div>
          </v-flex>
          <v-flex v-else sm6 xs12 mb-4>
            <div id="wrapper" data-tf-widget="nP801yfQ" :data-tf-hidden="dataTfHidden" data-tf-inline-on-mobile data-tf-medium="snippet" style="width:100%;height:100%;"></div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
  }),
  async mounted() {
    let script = document.createElement('script')
    script.src = 'https://embed.typeform.com/next/embed.js'
    document.body.appendChild(script)
  },
  computed: {
    ...mapGetters({
      user: "user"
    }),
    dataTfHidden() {
      return `email=${this.user.data.email},first_name=${this.user.data.firstName},full_name=${[this.user.data.fullName, this.user.data.lastName].filter(Boolean).join(' ')}`
    }
  },
  methods: {
    
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Roadmap",
    "b": "Nous souhaitons créer d'autres services pour vous.",
    "c": "Nous sommes convaincus que l'intelligence artificielle peut vous aider au quotidien en exploitant automatiquement les données de vos CVs en grande quantité.",
    "d": "Choisissez vos futures fonctionnalités avec ce court sondage de 2 questions.",
    "e": "Descriptions des fonctionnalités :",
    
    "feature1Title": "Recherche rapide de CVs",
    "feature1Description": "Outil de recherche rapide et efficace dans l’ensemble de vos CVs.",

    "feature2Title": "Centralisation des CVs",
    "feature2Description": "Centraliser tous les CVs issus des différents départements ou des différentes entreprises d’un même groupe.",

    "feature3Title": "Matching",
    "feature3Description": "À partir du descriptif d’une offre de mission, automatiquement lister les CVs les plus pertinents de votre vivier, en vous affichant pour chacun pourquoi ce CV est pertinent.",

    "feature4Title": "Rédaction automatique d’un email ultra-personnalisé au candidat",
    "feature4Description": "Écrire instantanément un email éditable, qui soit personnalisé pour chaque candidat afin de lui présenter la mission en lui expliquant pourquoi cette mission lui correspond.",

    "feature5Title": "Aide à la gestion de l’écart entre un CV et une mission",
    "feature5Description": "Vous indiquer ce qui manque à un CV pour être pertinent pour une mission spécifique, afin de vous aider à ajuster son dossier de compétences.",

    "feature6Title": "Rédaction automatique d’un email ultra-personnalisé au client final",
    "feature6Description": "Rédiger automatiquement un email éditable, à destination du client final afin de lui présenter un candidat en lui justifiant précisément pourquoi ce candidat est pertinent.",

    "feature7Title": "Cartographie instantanée des compétences",
    "feature7Description": "Pouvoir automatiquement créer un rapport sur les compétences de vos employés pour répondre à la requête d’un client. Aussi, comparer les compétences de votre vivier actuel avec les compétences habituellement demandées dans vos offres de mission."
  },
  "en": {
    "a": "Roadmap",
    "b": "We want to create new services for you.",
    "c": "We believe that artificial intelligence can help you every day by automatically exploiting the data present in your CVs in big quantity.",
    "d": "Choose your next features with this short 2-questions survey.",
    "e": "Features descriptions:",

    "feature1Title": "Quickly search your CVs",
    "feature1Description": "Fast and efficient search tool for all your CVs.",

    "feature2Title": "Centralization of multiple CVs sources",
    "feature2Description": "Centralise all CVs from different departments or companies within the same group.",

    "feature3Title": "Matching",
    "feature3Description": "From the description of a job offer, automatically list the most relevant CVs, showing you for each one why this CV is relevant.",

    "feature4Title": "Automatic writing of an ultra-personalised email for the candidate",
    "feature4Description": "Instantly write an editable email that is personalised for each candidate to present the assignment and explain why it is relevant to them.",

    "feature5Title": "Assistance to manage the gap between a CV and a mission",
    "feature5Description": "Tell you what is missing from a CV to be relevant for a specific assignment, to help you adjust the content of his resume.",

    "feature6Title": "Automatic writing of an ultra-personalised email for the end client",
    "feature6Description": "Automatically write an editable email to the end client to introduce a candidate and justify precisely why that candidate is relevant.",

    "feature7Title": "Instant skills mapping",
    "feature7Description": "Automatically create a report of your employees' skills in response to a client's request. Also, compare the skills in your current pool with the skills typically required in your job offers."
  }
}
</i18n>